import * as z from "zod/v4";

/**
 * A split with its associated treatments, used for A/B test display.
 * This is an RPC response type with IDs serialized to strings for frontend consumption.
 */
const automationOutreachSplitWithTreatmentsZodSchema_ = z.object({
  split: z.object({
    _id: z.string(),
    name: z.string(),
    active: z.boolean().optional(),
  }),
  treatments: z.array(
    z.object({
      _id: z.string(),
      templateName: z.string(),
      percentage: z.number(),
      isControl: z.boolean(),
      templateId: z.string().optional(),
    }),
  ),
});
export const automationOutreachSplitWithTreatmentsZodSchema: z.ZodType<AutomationOutreachSplitWithTreatments> =
  automationOutreachSplitWithTreatmentsZodSchema_;
export interface AutomationOutreachSplitWithTreatments
  extends z.infer<typeof automationOutreachSplitWithTreatmentsZodSchema_> {}

/** A single treatment/variant in an A/B test response. */
export type Treatment =
  AutomationOutreachSplitWithTreatments["treatments"][number];

export const getAutomationOutreachSplit = {
  name: "getAutomationOutreachSplit" as const,
  input: z.object({ automationId: z.string(), automationStepId: z.string() }),
  output: automationOutreachSplitWithTreatmentsZodSchema.nullable(),
};
